import React from "react";

/**
 * Consistent page header for admin sections.
 */
export default function AdminPageHeader({ eyebrow, title, description, actions }) {
  return (
    <header className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0">
        {eyebrow ? (
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#3e2723]/45">{eyebrow}</p>
        ) : null}
        <h1 className="font-display mt-1 text-2xl font-bold tracking-tight text-[#3e2723] sm:text-[1.75rem]">
          {title}
        </h1>
        {description ? (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-[#3e2723]/62">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}

export function AdminCard({ className = "", children }) {
  return (
    <section
      className={`overflow-hidden rounded-2xl border border-[#3e2723]/10 bg-white shadow-[0_8px_30px_-18px_rgba(62,39,35,0.18)] ${className}`}
    >
      {children}
    </section>
  );
}

export function AdminCardHeader({ className = "", children }) {
  return (
    <div className={`border-b border-[#3e2723]/8 bg-[#faf8f8]/80 px-5 py-4 sm:px-6 ${className}`}>{children}</div>
  );
}

export function AdminCardBody({ className = "", children }) {
  return <div className={`px-5 py-5 sm:px-6 ${className}`}>{children}</div>;
}
